/* eslint-disable no-undef */
// NOTE: Makes use of global scrollmagic/gsap scripts that are loaded before toolkit.js in default.html template.
const debounce = require('../helpers/debounce');

const $navbar = document.querySelector('.navbar'); // Height from navbar to determine offset for elements
const $wrappers = document.querySelectorAll('.js-scrollmagic');

const sliding = $wrapper => {
	$wrapper.classList.add('is-sliding');
	const id = $wrapper.getAttribute('id');
	const controller = new ScrollMagic.Controller();

	// Supports hero and banner without requiring the BE to set additional classes/attributes
	$wrapper.querySelectorAll('.hero, .banner').forEach($el => {
		$el.classList.add('scrollmagic-component');
	});
	$wrapper.querySelectorAll('.hero-body, .banner-body').forEach($el => {
		$el.classList.add('scrollmagic-component-body');
	});

	// define movement of panels
	const timeline = new TimelineMax()
		.fromTo(
			`#${id} .scrollmagic-component:nth-child(1) .scrollmagic-component-body`,
			0.5,
			{ opacity: 0 },
			{ opacity: 1, ease: Linear.easeNone },
			'first'
		) // show text
		.fromTo(
			`#${id} .scrollmagic-component:nth-child(1)`,
			1,
			{ y: '0%' },
			{ y: '0%', ease: Linear.easeNone },
			'second'
		) // pause for a moment before continuing regular scroll
		.fromTo(
			`#${id} .scrollmagic-component:nth-child(1)`,
			1,
			{ x: '0' },
			{ x: '-100%', ease: Linear.easeNone },
			'third'
		) // out to left
		.fromTo(
			`#${id} .scrollmagic-component:nth-child(2) .scrollmagic-component-body`,
			1,
			{ opacity: 0 },
			{ opacity: 1, ease: Linear.easeNone },
			'fourth'
		) // show text
		.fromTo(
			`#${id} .scrollmagic-component:nth-child(2)`,
			1,
			{ y: '0%' },
			{ y: '0%', ease: Linear.easeNone },
			'fifth'
		); // pause for a moment before continuing regular scroll

	// create scene to pin and link animation
	new ScrollMagic.Scene({
		triggerElement: `#${id}`,
		triggerHook: 'onLeave',
		duration: '200%',
		offset: -$navbar.offsetHeight // Prevents triggerElement from having to scroll underneath the navigation before triggering
	})
		.setPin(`#${id}`)
		.setTween(timeline)
		.addTo(controller);
};

const curtain = $wrapper => {
	$wrapper.classList.add('is-curtain');
	const id = $wrapper.getAttribute('id');
	const controller = new ScrollMagic.Controller();

	// Supports hero and banner without requiring the BE to set additional classes/attributes
	$wrapper.querySelectorAll('.hero, .banner').forEach($el => {
		$el.classList.add('scrollmagic-component');
	});
	$wrapper.querySelectorAll('.hero-body, .banner-body').forEach($el => {
		$el.classList.add('scrollmagic-component-body');
	});
	// Support any first children that didn't receive the needed classes
	[...$wrapper.children].forEach($el => {
		$el.classList.add('scrollmagic-component');
	});

	// define movement of panels
	const timeline = new TimelineMax()
		.fromTo(
			`#${id} .scrollmagic-component:nth-child(1) .scrollmagic-component-body`,
			0.5,
			{ y: '40px' },
			{ y: '0px', ease: Linear.easeNone },
			'first'
		) // show text
		.fromTo(
			`#${id} .scrollmagic-component:nth-child(1)`,
			1,
			{ y: '0%' },
			{ y: '-100%', ease: Linear.easeNone },
			'second'
		) // out to top
		.fromTo(
			`#${id} .scrollmagic-component:nth-child(2)`,
			1,
			{ y: '50%' },
			{ y: '0%', ease: Linear.easeNone },
			'second'
		) // in from bottom
		.fromTo(
			`#${id} .scrollmagic-component:nth-child(2)`,
			0.25,
			{ y: '0%' },
			{ y: '0%', ease: Linear.easeNone },
			'third'
		); // pause for a moment before continuing regular scroll

	// create scene to pin and link animation
	new ScrollMagic.Scene({
		triggerElement: `#${id}`,
		triggerHook: 'onLeave',
		duration: document.querySelector(`#${id}`).scrollHeight,
		offset: -$navbar.offsetHeight // Prevents triggerElement from having to scroll underneath the navigation before triggering
	})
		.setPin(`#${id}`)
		.setTween(timeline)
		.addTo(controller);
};

const setHeightPerType = ($w, type) => {
	if (type === 'curtain' || type === 'sliding') {
		// Set height based on first element
		$w.style.height = `${$w.children[0].scrollHeight}px`;
	}
};

const init = function() {
	if ($wrappers.length === 0) return;

	$wrappers.forEach($w => {
		const type = $w.getAttribute('data-scrollmagic-type');
		if (!type) {
			console.warn('No data-scrollmagic-type for js-scrollmagic element set');
			return;
		}

		// Give ids to each wrapper, since ScrollMagic Scenes initialize per 1 unique element
		$w.setAttribute(
			'id',
			`scrollmagic${Math.random()
				.toString(36)
				.substr(2, 9)}`
		);

		// Set initialized class (so that without initialized class / nojs the page still looks representable)
		$w.classList.add('is-initialized');

		setHeightPerType($w, type);

		// Init by type
		if (type === 'curtain') {
			curtain($w);
		} else if (type === 'sliding') {
			sliding($w);
		}
	});

	// Update height on resize as related elements' height might change
	const onResize = () => {
		$wrappers.forEach($w => {
			setHeightPerType($w, $w.getAttribute('data-scrollmagic-type'));
		});
	};
	const debounced = debounce(onResize, 300);
	window.addEventListener('resize', debounced);
};

module.exports = {
	init
};
